window.meter_management_requests_periodpicker = function () {
    var instance = {
        init: function () {
            var icon = document.getElementById("metermanagementrequests_filterperiod_btn");
            if (icon) {
                icon.style = "position: relative; order: -1; margin-left: 4px;";
            }
            else {
                setTimeout(() => {
                    icon = document.getElementById("metermanagementrequests_filterperiod_btn");
                    if (icon) {
                        icon.style = "position: relative; order: -1; margin-left: 4px;";
                    }
                }, 0)
            }
        },
    };
    return instance;
}();